// extracted by mini-css-extract-plugin
export default {"image":"AppointmentServices_image__gHGG5","logo":"AppointmentServices_logo__665RV","checkbox":"AppointmentServices_checkbox__JJxI1","active":"AppointmentServices_active__-5kbb"};